import {useContext, useEffect, useState} from 'react';
import {collection, onSnapshot, query} from 'firebase/firestore';
import {where} from '-/data/firestoreQuery';

import {db} from '-/firebase';
import {UserContext} from '-/contexts/User';
import {hasFeature} from '-/features';
import {hasPermission} from '-/data/utils';

// Live count of the deployments currently out — drives the badge on the
// Deployments menu item.
//
// ACTIVE is the operational state: the apparatus is away and the record is
// still being filled in. COMPLETED and LOCKED are history (#1447) and don't
// count — the badge answers "what have we got out right now", which is the
// question an officer opens the sidebar with.
//
// Unlike the assignments badge this is department-wide rather than personal:
// a deployment is the department's, and half of them have nobody from the
// department on them at all (#1514).
export default function useDeploymentBadge() {
    const {currentUser} = useContext(UserContext);
    // Recomputed on every render, so toggling the feature in Settings
    // resubscribes live — useMenuItems re-renders on the settings context.
    const enabled = hasFeature('deployments') && hasPermission(currentUser, 'deployments.read');
    const [count, setCount] = useState(0);

    useEffect(() => {
        // Don't fire a read the rules would deny for someone without the
        // permission (or with the feature switched off).
        if (!enabled) {
            setCount(0);
            return undefined;
        }
        const q = query(collection(db, 'deployments'), where('status', '==', 'ACTIVE'));
        const unsub = onSnapshot(q, snap => setCount(snap.size), err => {
            console.error('Error loading deployment badge count:', err);
            setCount(0);
        });
        return () => unsub();
    }, [enabled]);

    return count;
}
